// extracted by mini-css-extract-plugin
export default {"root":"style-module__root___RBkvH","root__wrapper":"style-module__root__wrapper___Jlsz2","root__actions":"style-module__root__actions____ze_H","root__actions_save":"style-module__root__actions_save___vBXk9"};
    if(module.hot) {
      // 1697460474216
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  